module.exports = __webpack_public_path__ + "media/images/lb/529-37fb30cad1d6af0e5666a68d662684df.svg";